import Vue from 'vue'
import axios from 'axios'
import { store } from '@/store/store'

const axiosInstance = axios.create()
const pendingRequests = new Map()

axiosInstance.interceptors.request.use((config) => {
    // Generate an identifier for each request
    const requestIdentifier = `${config.url}_${config.method}`

    const requestCancelList = [
        '/Account/SignIn_post',
        '/Query/QueryRequestList_post',
        '/Query/QueryTaskList_post',
        '/Query/QueryRequisitionList_post',
        '/Query/QueryTaskWithRoutineList_post',
        '/Query/QueryTaskTemplateList_post'
    ]

    // Check if there is already a pending request with the same identifier
    if (pendingRequests.has(requestIdentifier) && requestCancelList.includes(requestIdentifier)) {
        const cancelTokenSource = pendingRequests.get(requestIdentifier)

        // Cancel the previous request
        cancelTokenSource.cancel(`Cancelled due to new request (${requestIdentifier})`)
    }

    // Create a new CancelToken
    const newCancelTokenSource = axios.CancelToken.source()

    config.cancelToken = newCancelTokenSource.token
    config.baseURL = process.env.WEBAPI_ENDPOINT
    config.withCredentials = true

    // Store the new cancel token source in the map
    pendingRequests.set(requestIdentifier, newCancelTokenSource)

    return config
}, (error) => {
    // Return the error if the request fails
    return Promise.reject(error)
})
axiosInstance.interceptors.response.use((response) => {
    // Remove completed request from pending map
    const requestIdentifier = `${response.config.url}_${response.config.method}`

    pendingRequests.delete(requestIdentifier)

    return response
}, (error) => {
    // Remove failed request from pending map
    if (error.config) {
        const requestIdentifier = `${error.config.url}_${error.config.method}`

        pendingRequests.delete(requestIdentifier)
    }

    if (axios.isCancel(error)) {
        console.log('response.use, Request cancelled', error.message)
    } else {
        return Promise.reject(error)
    }
})

export default {
    get (url, request) {
        return axiosInstance.get(url, {
            params: request
        })
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    },
    post (url, request) {
        return axiosInstance.post(url, request)
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                if (store.getters.userInfo.userId !== null) {
                    if (error.response) {
                        if (error.response.status === 401) {
                            Vue.prototype.$notify({
                                group: 'info',
                                type: 'error',
                                text: 'Noget gik galt, prøv at logge ud og ind igen'
                            })
                            store.state.global.loginAgain = true
                        } else if (error.response.status === 500) {
                            Vue.prototype.$notify({
                                group: 'info',
                                type: 'error',
                                duration: 5000,
                                text: 'Noget gik galt, prøv igen (fejlmeddelelse: ' + error.response.data.Message + ')'
                            })
                        } else if (error.response.status === 409) {
                            Vue.prototype.$notify({
                                group: 'info',
                                type: 'error',
                                duration: 5000,
                                text: 'En anden bruger har for nylig gemt noget på din henvendelse/opgave, og dine rettelser kan derfor ikke gemmes.'
                            })
                        } else {
                            Vue.prototype.$notify({
                                group: 'info',
                                type: 'error',
                                text: 'Noget gik galt, prøv igen (fejlkode: ' + error.response.status + ')'
                            })
                            console.error('error.response.status', error.response.status)
                            console.error('error.response.data', error.response.data)
                            console.error('error.response.headers', error.response.headers)
                        }
                    } else if (error.request) {
                        Vue.prototype.$notify({
                            group: 'info',
                            type: 'error',
                            text: 'Netværksfejl. Forespørgsel kan ikke sendes til server. Prøv igen (fejl: ' + error.request + ')'
                        })
                        console.error('error.request', error.request)
                    } else {
                        Vue.prototype.$notify({
                            group: 'info',
                            type: 'error',
                            text: 'Noget gik galt, prøv igen (fejlmeddelelse: ' + error.message + ')'
                        })
                    }
                }

                return Promise.reject(error)
            })
    },
    patch (url, request) {
        return axiosInstance.patch(url, request)
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    },
    delete (url, request) {
        return axiosInstance.delete(url, request)
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    },
    uploadDocument (url, objectReferenceId, dateReference, description, formData) {
        if (formData.has('objectReferenceId') || formData.has('dateReference')) {
            formData.delete('objectReferenceId')
            formData.delete('dateReference')
            formData.delete('description')
        }
        formData.append('objectReferenceId', objectReferenceId)
        formData.append('dateReference', dateReference)
        formData.append('description', description)

        return axiosInstance.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    },
    downloadDocument (url, request) {
        return axiosInstance.get(url, {
            params: request,
            responseType: 'arraybuffer'
        })
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    },
    downloadExcel (url, request) {
        return axiosInstance.post(url, request, {
            params: {
                type: request.type
            },
            responseType: 'arraybuffer'
        })
            .then((response) => {
                return Promise.resolve(response)
            })
            .catch((error) => {
                return Promise.reject(error)
            })
    },
    getBaseUrl () {
        return process.env.WEBAPI_ENDPOINT
    }
}



// WEBPACK FOOTER //
// ./src/store/api.js